import React from 'react';
import PropTypes from 'prop-types';
import { ImageIcon } from 'lucide-react';
import { PinItem } from 'v1/components/shared';
import isEmpty from 'lodash/isEmpty';
import classnames from 'classnames';
import { TailwindRoot } from '~/v4/shared/TailwindRoot';

import './ApplicantCarousel.scss';

const ApplicantCarousel = ({ files, appearance, height }) => {
  const isFill = appearance === 'fill';
  const hasFiles = !isEmpty(files);
  const resolvedHeight = height ?? (isFill || !hasFiles ? undefined : 250);

  function renderItems(fileList) {
    const list = fileList.map(pin => (
      <PinItem
        key={pin.id}
        className="ApplicantCarousel-pinItem"
        pin={pin}
        settings={{
          video: {
            showPreview: true,
            height: isFill ? '100%' : '250px'
          }
        }}
      />
    ));

    return (
      <div
        className="ApplicantCarousel-scrollContainer"
        style={resolvedHeight != null ? { height: resolvedHeight } : undefined}
      >
        {list}
      </div>
    );
  }

  function renderEmpty() {
    return (
      <TailwindRoot className="contents">
        <div
          className={classnames(
            'ApplicantCarousel-empty',
            isFill
              ? 'ApplicantCarousel-empty_compact'
              : 'flex flex-col items-center justify-center gap-1 py-8 px-4 text-center'
          )}
        >
          {isFill ? (
            <>
              <img
                src="/images/icon_colour_media.svg"
                alt=""
                width="32"
                height="32"
              />
              <span>No files submitted</span>
            </>
          ) : (
            <>
              <ImageIcon
                className="size-8 text-fg-muted opacity-60"
                aria-hidden
              />
              <h3 className="text-base font-medium text-fg-default">
                No files submitted
              </h3>
              <p className="text-sm text-fg-muted">
                Applicant did not submit files
              </p>
            </>
          )}
        </div>
      </TailwindRoot>
    );
  }

  return (
    <div
      className={classnames(
        { [`ApplicantCarousel-appearance_${appearance}`]: appearance },
        'ApplicantCarousel'
      )}
      style={
        hasFiles && resolvedHeight != null
          ? { height: resolvedHeight }
          : undefined
      }
    >
      {hasFiles ? renderItems(files) : renderEmpty()}
    </div>
  );
};

ApplicantCarousel.defaultProps = {
  appearance: 'fill'
};

ApplicantCarousel.propTypes = {
  files: PropTypes.array,
  appearance: PropTypes.oneOf(['fill', 'inline']),
  height: PropTypes.number
};

export default ApplicantCarousel;
